import { Armchair, LampWallUp, PackageOpen, Sprout } from "lucide-react";
import { catalogById } from "../../data/catalog";
import type { BalconyProfile, DesignItem } from "../../data/model";
import { PlantArt } from "../../components/PlantArt";

interface Props {
  profile: BalconyProfile;
  design: DesignItem[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

const typeIcon = {
  plant: Sprout,
  pot: PackageOpen,
  furniture: Armchair,
  accessory: LampWallUp,
};

export function PlanCanvas({ profile, design, selectedId, onSelect }: Props) {
  return (
    <div className="plan-canvas-wrap">
      <div className="canvas-ruler ruler-top" aria-hidden="true"><span>0</span><span>{Math.round(profile.widthCm / 2)}</span><span>{profile.widthCm} cm</span></div>
      <div
        className={`plan-canvas light-${profile.light}`}
        style={{ aspectRatio: `${Math.max(profile.widthCm, 140)} / ${Math.max(profile.depthCm, 70)}` }}
        aria-label={`Sơ đồ ban công ${profile.widthCm} x ${profile.depthCm} cm`}
      >
        <div className="canvas-sun" aria-hidden="true" />
        <div className="canvas-rail" aria-hidden="true"><span>LAN CAN</span></div>
        <div className="canvas-door" aria-hidden="true"><span>CỬA</span></div>
        <div className="canvas-aisle" aria-hidden="true"><span>LỐI ĐI</span></div>
        {design.map((item) => {
          const record = catalogById.get(item.refId);
          if (!record) return null;
          const Icon = typeIcon[item.type];
          const size = item.type === "furniture" ? "large" : item.type === "plant" ? "plant" : "small";
          return (
            <button
              key={item.instanceId}
              type="button"
              className={`canvas-item canvas-item-${item.type} canvas-item-${size} ${selectedId === item.instanceId ? "selected" : ""}`}
              style={{ left: `${Math.min(93, Math.max(5, item.x))}%`, top: `${Math.min(82, Math.max(8, item.y))}%` }}
              onClick={() => onSelect(item.instanceId)}
              aria-pressed={selectedId === item.instanceId}
              aria-label={`${record.name}, số lượng ${item.qty}, vùng ${zoneLabel(item.zone)}`}
            >
              {item.type === "plant" ? <PlantArt mediaKey={record.mediaKey} label={record.name} /> : <Icon aria-hidden="true" />}
              <span>{record.name}</span>
              {item.qty > 1 && <b>×{item.qty}</b>}
            </button>
          );
        })}
      </div>
      <div className="canvas-legend" aria-label="Chú giải">
        <span><i className="legend-sun" /> Vệt nắng</span>
        <span><i className="legend-aisle" /> Lối đi</span>
        <span><i className="legend-plant" /> Cây</span>
        <span><i className="legend-furniture" /> Nội thất</span>
      </div>
      <details className="canvas-text-list">
        <summary>Danh sách vật thể trong sơ đồ</summary>
        <ul>
          {design.map((item) => {
            const record = catalogById.get(item.refId);
            return record ? <li key={item.instanceId}>{record.name} ×{item.qty}, vùng {zoneLabel(item.zone)}</li> : null;
          })}
        </ul>
      </details>
    </div>
  );
}

export const zoneLabel = (zone: DesignItem["zone"]) => (zone === "left" ? "trái" : zone === "center" ? "giữa" : "phải");
